var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScanQr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Scan_QR",
    "data-name": "Scan QR",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.237,
    height: 22.242,
    viewBox: "0 0 22.237 22.242",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M92.985,237.5h-10a.992.992,0,0,1-1.062-.748.966.966,0,0,1,.694-1.171,1.808,1.808,0,0,1,.418-.04q9.975,0,19.949,0a1.653,1.653,0,0,1,.488.062.969.969,0,0,1-.12,1.865,2.055,2.055,0,0,1-.394.031Q97.972,237.5,92.985,237.5Z",
    transform: "translate(-81.892 -225.401)",
    fill: "#8e8e8e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M299.872,84.512h-.322c-1.638,0-3.275,0-4.913,0a.97.97,0,0,1-.942-1.33.98.98,0,0,1,.958-.616q2.146,0,4.292,0c.629,0,1.257,0,1.886,0a.964.964,0,0,1,.988.991q.007,3.1,0,6.2a.973.973,0,0,1-1.905.3,1.686,1.686,0,0,1-.041-.442q0-2.395,0-4.79Z",
    transform: "translate(-279.585 -82.561)",
    fill: "#8e8e8e"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M299.965,300.632v-.789c0-1.481,0-2.962,0-4.442a.969.969,0,0,1,1.3-.958.955.955,0,0,1,.642.889q.008,3.152,0,6.3a.951.951,0,0,1-.983.944q-3.114.007-6.228,0a.972.972,0,1,1,0-1.944c1.646-.006,3.292,0,4.938,0Z",
    transform: "translate(-279.678 -280.34)",
    fill: "#8e8e8e"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M83.811,300.715h1.212c1.348,0,2.7-.005,4.044,0a.966.966,0,0,1,.93,1.3.956.956,0,0,1-.89.64q-3.151.008-6.3,0a.947.947,0,0,1-.94-.961q-.009-3.127,0-6.254a.962.962,0,0,1,.954-.973.95.95,0,0,1,.989.959c.01,1.4,0,2.8,0,4.194C83.811,299.976,83.811,300.33,83.811,300.715Z",
    transform: "translate(-81.859 -280.423)",
    fill: "#8e8e8e"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M83.815,84.527v.319c0,1.63,0,3.259,0,4.889a.974.974,0,1,1-1.946.041c-.005-1.233,0-2.465,0-3.7,0-.819,0-1.638,0-2.457A.975.975,0,0,1,82.9,82.579q3.052,0,6.1,0A.977.977,0,1,1,89,84.526q-2.432,0-4.863,0Z",
    transform: "translate(-81.864 -82.577)",
    fill: "#8e8e8e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanQr);
export default __webpack_public_path__ + "static/media/scan_qr.79be949fa0076190cc983923c103b59a.svg";
export { ForwardRef as ReactComponent };